import { GetPayeeQuery } from "#graphql/supergraphTypes";

export type GetPayeeQueryPayee = NonNullable<GetPayeeQuery["payee"]>;

// Extract specific types from the query result
export type GetPayeeQueryDocument = NonNullable<GetPayeeQueryPayee["payeeDocuments"]>[0];
export type GetPayeeQueryPaymentPrefDocument = NonNullable<
  GetPayeeQueryPayee["paymentPrefDocuments"]
>[0];
export type GetPayeeQueryAddress = NonNullable<GetPayeeQueryPayee["address"]>;
export type GetPayeeQueryPaymentPrefFull = NonNullable<
  GetPayeeQueryPayee["paymentPref"]
>["paymentPrefFull"];

export interface PayeeDetailsProps {
  onClose: () => void;
  payeeId?: string;
}

export enum PayeeDetailsTabs {
  Overview = "Overview",
  Log = "Log",
}
